/**
 * Mon Balade - Google Ads Conversion Tracking
 * AW Tag:    AW-17561053281
 * Conv Label:TncwCLjcloccEOHQ4bVB (Google Shopping App Purchase)
 * Updated:   2026-05-24 - FIXED correct AW tag + label
 */
(function() {
  var AW_ID    = "AW-17561053281";
  var CONV_LBL = "TncwCLjcloccEOHQ4bVB";

  // Load gtag.js
  var s = document.createElement("script");
  s.async = true;
  s.src = "https://www.googletagmanager.com/gtag/js?id=" + AW_ID;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag(){ dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", AW_ID, { send_page_view: true });

  // Fire purchase conversion on thank-you page
  function isThankYouPage() {
    return window.location.pathname.indexOf("thank_you") > -1 ||
           (window.Shopify && window.Shopify.checkout && window.Shopify.checkout.order_id);
  }

  function getOrderValue() {
    if (window.Shopify && window.Shopify.checkout && window.Shopify.checkout.total_price) {
      return parseFloat(window.Shopify.checkout.total_price) / 100;
    }
    var el = document.querySelector("[data-checkout-payment-due-target]");
    if (el) return parseFloat(el.getAttribute("data-checkout-payment-due-target")) / 100;
    return 0;
  }

  function getOrderId() {
    if (window.Shopify && window.Shopify.checkout && window.Shopify.checkout.order_id) {
      return String(window.Shopify.checkout.order_id);
    }
    var m = window.location.href.match(/\/orders\/([^?#]+)/);
    return m ? m[1] : "";
  }

  function fireConversion() {
    if (!isThankYouPage()) return;
    if (window.__mbConvFired) return;
    window.__mbConvFired = true;

    var val     = getOrderValue();
    var orderId = getOrderId();

    gtag("event", "conversion", {
      send_to:        AW_ID + "/" + CONV_LBL,
      value:          val,
      currency:       "EUR",
      transaction_id: orderId
    });

    gtag("event", "purchase", {
      value:          val,
      currency:       "EUR",
      transaction_id: orderId
    });

    console.log("[MonBalade] Conversion fired: EUR " + val + " | order " + orderId);
  }

  if (document.readyState === "complete") { fireConversion(); }
  else { window.addEventListener("load", fireConversion); }

})();
